import Loading from '@/shared/ui/Loading';

import asyncComponentLoader from './loader';
import type { AnyProps, LoadComponent, LoaderDefaultOptions } from './types';

// Loader debounce: skip the spinner if the async work finishes within `delay`ms;
// once shown, keep it up for at least `minimumLoading`ms to avoid a flash.
const loaderDefaultOptions: LoaderDefaultOptions = {
  delay: 300,
  minimumLoading: 700,
};

const configuredAsyncComponentLoader = (
  loadComponent: LoadComponent,
  additionalProps: AnyProps = {},
  loaderOptions: LoaderDefaultOptions = loaderDefaultOptions,
  FallbackWaiting = Loading,
) => asyncComponentLoader(loadComponent, additionalProps, loaderOptions, FallbackWaiting);

export { loaderDefaultOptions };
export default configuredAsyncComponentLoader;
